module.exports = __webpack_public_path__ + "static/laravel-99f0aabd4a99e892d0054a6f03bc18a9.png";